import HttpRequest from "@/services/http_request";

class EnrollProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  async getEnrollResult(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/enroll/enrollresult");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getEnrollApproveResult(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/enrollapproveresult");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getInvoicelist(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/staff/invoicelist");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async classReservelist(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid_list: this.variableParser(request.classid_list),
      reserveonly: this.variableParser(request.reserveonly),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/process/classreservelist", req);
    return data;
  }
  async getEnrollLog(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/enroll/enrolllog");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getEnrollTotal(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
    });
    const res = await this.get("reg/enroll/enroll/total");
    const { data } = res.data;
    return data;
  }

  async getEnroll(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/enroll");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getStdconfirmdetail(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/process/stdconfirmdetail");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getStdenrolldetail(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/process/stdenrolldetail");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async postEnroll(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.create("reg/enroll/enroll", payload);
    return data;
  }

  async deleteEnroll(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete("reg/enroll/enroll", {}, payload);
    return data;
  }

  async changeSection(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.create(
      "reg/enroll/enrollchangesection",
      payload
    );
    return data;
  }

  async getEnrollStat(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
    });
    const res = await this.get("reg/enroll/enrollstat");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async confirmEnroll(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.create("reg/enroll/enrollconfirm", payload);
    return data;
  }

  async getSearchProgram(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const reqData = {
      // Authorization: `Bearer ${this.variableParser(token)}`,
      lang: this.variableParser(request.lang),
      programyear: this.variableParser(request.programyear),
      facultyid: this.variableParser(request.facultyid),
      levelid: this.variableParser(request.levelid),
      departmentid: this.variableParser(request.departmentid),
      programcode: this.variableParser(request.programcode),
      programname: this.variableParser(request.programname),
    };
    const res = await this.get("reg/enroll/searchprogram", reqData);
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async searchStudentCode(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const tempReq = {
      studentcode: this.variableParser(request.studentcode),
      studentname: this.variableParser(request.studentname),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      levelid: this.variableParser(request.levelid),
      studentstatusfrom: this.variableParser(request.studentstatusfrom),
      studentstatusto: this.variableParser(request.studentstatusto),
      lang: this.variableParser(request.lang),
    };
    const res = await this.get("reg/enroll/searchstudentcode", tempReq);
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async searchStudent(payload) {
    const { token, request } = payload;
    const tempReq = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      officerid: this.variableParser(request.officerid),
      regstatus: this.variableParser(request.regstatus),
      preregstatus: this.variableParser(request.preregstatus),
      lang: this.variableParser(request.lang),
    };
    if (request.facultyid && request.facultyid != 0) {
      tempReq.facultyid = this.variableParser(request.facultyid);
    }
    if (request.departmentid && request.departmentid != 0) {
      tempReq.departmentid = this.variableParser(request.departmentid);
    }
    if (request.programid && request.programid != 0) {
      tempReq.programid = this.variableParser(request.programid);
    }
    if (request.studentyear && request.studentyear != 0) {
      tempReq.studentyear = this.variableParser(request.studentyear);
    }
    if (request.studentcodefrom && request.studentcodefrom != "") {
      tempReq.studentcodefrom = this.variableParser(request.studentcodefrom);
    }
    if (request.studentcodeto && request.studentcodeto != "") {
      tempReq.studentcodeto = this.variableParser(request.studentcodeto);
    }
    if (request.studentstatusfrom && request.studentstatusfrom != "") {
      tempReq.studentstatusfrom = this.variableParser(
        request.studentstatusfrom
      );
    }
    if (request.studentstatusto && request.studentstatusto != "") {
      tempReq.studentstatusto = this.variableParser(request.studentstatusto);
    }
    this.setHeader(tempReq);
    const res = await this.get("reg/enroll/searchstudent");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async searchCourse(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const tempReq = {
      coursecode: this.variableParser(request.coursecode),
      coursename: this.variableParser(request.coursename),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      lang: this.variableParser(request.lang),
    };
    const res = await this.get("reg/enroll/course", tempReq);
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async searchConfirmResult(payload) {
    const { token, request } = payload;
    const tempReq = {
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      coursecode: this.variableParser(request.coursecode),
      classtype: this.variableParser(request.classtype),
      section: this.variableParser(request.section),
      confirm_flag:
        this.variableParser(request.confirmFlag) != "0"
          ? this.variableParser(request.confirmFlag)
          : "",
      approve_flag:
        this.variableParser(request.approveFlag) != "0"
          ? this.variableParser(request.approveFlag)
          : "",
      extra_flag:
        this.variableParser(request.exFlag) != "0"
          ? this.variableParser(request.exFlag)
          : "",
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      ...tempReq,
    });
    const res = await this.get("reg/enroll/process/reqconfirmresult");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async reqConfirmDetail(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid: this.variableParser(request.classid),
      userid: this.variableParser(request.userid),
      schedule_period: this.variableParser(request.schedule_period),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/process/reqconfirmdetail");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async adjustExtraRegister(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classid: this.variableParser(request.classid),
      extraregister: this.variableParser(request.extraregister),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const res = await this.update(
      "reg/enroll/process/adjustextraregister",
      req
    );
    return res.data;
  }

  async adjustTotalSeat(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classid: this.variableParser(request.classid),
      totalsumseat: this.variableParser(request.totalsumseat),
      userid: this.variableParser(request.userid),
      ipaddress: "127.0.0.1", //this.variableParser(request.ipaddress),
      lang: this.variableParser(request.lang),
    };
    const res = await this.update("reg/enroll/process/adjusttotalseat", req);
    return res.data;
  }

  async reqConfirm(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid: this.variableParser(request.classid),
      confirmtype: this.variableParser(request.confirmtype),
      totalrequest: this.variableParser(request.totalrequest),
      totalconfirm: this.variableParser(request.totalconfirm),
      studentidlist: this.variableParser(request.studentidlist),
      userid: this.variableParser(request.userid),
      ipaddress: "127.0.0.1", //this.variableParser(request.ipaddress),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/process/reqconfirm", req);
    return res.data;
  }

  async reqConfirmStudentDetail(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      formtype: this.variableParser(request.formtype),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/process/reqconfirmstudentdetail");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async delReqConfirmStudentDetail(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/process/reqconfirmstudentdetail",
      {},
      {
        classid: this.variableParser(request.classid),
        studentidlist: this.variableParser(request.studentidlist),
        userid: this.variableParser(request.userid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async getPreApprove(payload) {
    const { token, request } = payload;
    const tempReq = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      section: this.variableParser(request.section),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    if (request.coursecode !== undefined && request.coursecode != "") {
      tempReq.coursecode = this.variableParser(request.coursecode);
    }
    this.setHeader(tempReq);
    const res = await this.get("reg/enroll/process/preapprove");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async getPreApproveStudent(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/process/preapprovestudent");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async preApprove(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classidlist: this.variableParser(request.classidlist),
      approvetype: this.variableParser(request.approvetype),
      userid: this.variableParser(request.userid),
      ipaddress: "127.0.0.1", //this.variableParser(request.ipaddress),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/process/preapprove", req);
    return res.data;
  }

  async delPreapprovestudent(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/process/preapprovestudent",
      {},
      {
        classid: this.variableParser(request.classid),
        studentidlist: this.variableParser(request.studentidlist),
        userid: this.variableParser(request.userid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }

  async getClassReserve(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      coursecode: this.variableParser(request.coursecode),
      section: this.variableParser(request.section),
      classtype: this.variableParser(request.classtype),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/process/classreserve");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async getClassReserveStudent(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang),
    });
    const res = await this.get("reg/enroll/process/classreservestudent");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async updateClassReserve(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classid: this.variableParser(request.classid),
      reserveonly: this.variableParser(request.reserveonly),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const res = await this.update("reg/enroll/process/classreserve", req);
    return res.data;
  }

  async delClassReserveStudent(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/process/classreservestudent",
      {},
      {
        classid: this.variableParser(request.classid),
        studentidlist: this.variableParser(request.studentidlist),
        userid: this.variableParser(request.userid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }

  async classReserveStudent(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classid: this.variableParser(request.classid),
      studentidlist: this.variableParser(request.studentidlist),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create(
      "reg/enroll/process/classreservestudent",
      req
    );
    return res.data;
  }

  async getClassReserveSearchStudent(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classid: this.variableParser(request.classid),
      studentcode: this.variableParser(request.studentcode),
      studentname: this.variableParser(request.studentname),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      levelid: this.variableParser(request.levelid),
      studentstatusto: this.variableParser(request.studentstatusto),
      studentstatusfrom: this.variableParser(request.studentstatusfrom),
      lang: this.variableParser(request.lang),
    };
    const res = await this.get(
      "reg/enroll/process/classreservesearchstudent",
      req
    );
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async getClassAdjustResult(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      coursecode: this.variableParser(request.coursecode),
      classtype: this.variableParser(request.classtype),
      section: this.variableParser(request.section),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/classadjustresult");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }

  async saveClassadJustResult(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classid_list: this.variableParser(request.classid_list),
      totalsumseat_list: this.variableParser(request.totalsumseat_list),
      ipaddress: "127.0.0.1", //this.variableParser(request.ipaddress),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/coordinator/saveclassadjustresult", req);
    return data;
  }

  async getCheckapprove(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      coursecode: this.variableParser(request.coursecode),
      section: this.variableParser(request.section),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/checkapprove");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async checkapprovebycoursesel(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      courseid: this.variableParser(request.courseid),
      section: this.variableParser(request.section),
      period: this.variableParser(request.period),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/checkapprovebycoursesel");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async checkapprovebystusel(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid: this.variableParser(request.classid),
      period: this.variableParser(request.period),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/checkapprovebystusel");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async classprechangebycoursesel(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      courseid: this.variableParser(request.courseid),
      section: this.variableParser(request.section),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/classprechangebycoursesel");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async saveClassregstatus(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classregis: this.variableParser(request.classregis),
      classid_list: this.variableParser(request.classid_list),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/coordinator/classregstatus", req);
    return data;
  }
  async saveClassregstatusOnlyone(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classregis: this.variableParser(request.classregis),
      classid_list: this.variableParser(request.classid_list),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/coordinator/classregstatusonlyone", req);
    return data;
  }
  async getClassregstatus(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      courseid: this.variableParser(request.courseid),
      classregis: this.variableParser(request.classregis),
      section: this.variableParser(request.section),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/classregstatus");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async classprechangebystudent(payload) {
      const { token, request } = payload;
      const req = {
        Authorization: `Bearer ${this.variableParser(token)}`,
        acadyear: this.variableParser(request.acadyear),
        semester: this.variableParser(request.semester),
        courseid: this.variableParser(request.courseid),
        section: this.variableParser(request.section),
        approve_status: this.variableParser(request.approve_status),
        userid: this.variableParser(request.userid),
        lang: this.variableParser(request.lang),
      };
      this.setHeader(req);
      const res = await this.get("reg/enroll/coordinator/classprechangebystudent");
      console.log("res", res)
      if (res.status == 500 || res.data.code === 403) {
        return [];
      }
      const { data } = res.data;
      return data;
    }
  async classprechangebystusel(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      admitacadyear: this.variableParser(request.admitacadyear),
      admitsemester: this.variableParser(request.admitsemester),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/classprechangebystusel");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async classprechangebystu(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/classprechangebystu");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async classprechangebystubysec(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      courseid: this.variableParser(request.courseid),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/classprechangebystubysec");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async coordinatorrightsel(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      courseid: this.variableParser(request.courseid),
      section: this.variableParser(request.section),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/coordinatorrightsel");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async saveCoordinatorrightbyco(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      coordinator_hdid: this.variableParser(request.coordinator_hdid),
      officerid: this.variableParser(request.officerid),
      can_adjust: this.variableParser(request.can_adjust),
      can_confirm: this.variableParser(request.can_confirm),
      can_manage: this.variableParser(request.can_manage),
      can_move: this.variableParser(request.can_move),
      can_resereve: this.variableParser(request.can_resereve),
      usertype_code: this.variableParser(request.usertype_code),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/coordinator/coordinatorrightbyco", req);
    return data;
  }
  async coordinatorrightbyco(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/coordinatorrightbyco");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async coordinatorrightbyfac(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/coordinatorrightbyfac");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async saveCoordinatorrightbyfac(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classid_list: this.variableParser(request.classid_list),
      usertypecode: this.variableParser(request.usertypecode),
      permit: this.variableParser(request.permit),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/coordinator/coordinatorrightbyfac", req);
    return data;
  }
  async saveConfigcredit(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      credit1: this.variableParser(request.credit1),
      credit2: this.variableParser(request.credit2),
      credit3: this.variableParser(request.credit3),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/configcredit", req);
    return data;
  }
  async postEnrollRegExtraDetail(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/enrollregextradetail", req);
    if (res.status == 500) {
      return { code: 500, status: 500, message: res.message };
    }
    return res.data;
  }
  async saveEnrollregextra(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      usertype: this.variableParser(request.usertype),
      wauto: this.variableParser(request.wauto),
      classid: this.variableParser(request.classid),
      action: this.variableParser(request.action),
      userid: this.variableParser(request.userid),
      createip: this.variableParser(request.createip),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/enrollregextra", req);
    return data;
  }
  async delEnrollregextra(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/enrollregextra",
      {},
      {
        studentidlist: this.variableParser(request.studentidlist),
        classid: this.variableParser(request.classid),
        userid: this.variableParser(request.userid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async saveEnrollregextracon(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      usertype: this.variableParser(request.usertype),
      userid: this.variableParser(request.userid),
      createip: this.variableParser(request.createip),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/enrollregextracon", req);
    return data;
  }
  async adjustapprovesel(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      courseid: this.variableParser(request.courseid),
      section: this.variableParser(request.section),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/adjustapprovesel");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async adjustapprovelate(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/coordinator/adjustapprovelate");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async saveAdjustapprovelate(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      preregdtlid_list: this.variableParser(request.preregdtlid_list),
      approveflag: this.variableParser(request.approveflag),
      ipaddress: "127.0.0.1", //this.variableParser(request.ipaddress),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/coordinator/adjustapprovelate", req);
    return data;
  }
  async delConditionlist(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/adjustconditiondellist",
      {},
      {
        studentidlist: this.variableParser(request.studentidlist),
        erroridlist: this.variableParser(request.erroridlist),
        userid: this.variableParser(request.userid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async adjustconditionlog(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      errorid: this.variableParser(request.errorid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/adjustconditionlog");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async adjustconditionlogdetail(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/adjustconditionlogdetail");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getEnrollpstatus(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      courseid: this.variableParser(request.courseid),
      section: this.variableParser(request.section),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/enrollpstatus");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async saveEnrollstatus(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid: this.variableParser(request.classid),
      fee: this.variableParser(request.fee),
      userid: this.variableParser(request.userid),
      ipaddress: this.variableParser(request.ipaddress),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/enrollpstatus", req);
    return data;
  }
  async enrollmaintainstatus(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      studentstatus: this.variableParser(request.studentstatus),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/enrollmaintainstatus");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async enrollmaintainstatuscheck(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
     studentstatus: this.variableParser(request.studentstatus),
     checkmaintain: this.variableParser(request.checkmaintain),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/enrollmaintainstatuscheck");
    if (res.status == 500) {
      return [];
    }
    // const { data } = res.data;
    // return data;
    return res.data;
  }
  async saveEnrollmaintainstatus(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentstatus: this.variableParser(request.studentstatus),
      remark: this.variableParser(request.remark),
      checkmaintain: this.variableParser(request.checkmaintain),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/enrollmaintainstatus", req);
    return data;
  }
  async postClearpreregdata(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/clearpreregdata", req);
    return res.data;
  }
  async checklogpreregsel(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/checklogpreregsel");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async checklogprereg(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/checklogprereg");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async saveClassprechangebycourseschk(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentid_list: this.variableParser(request.studentid_list),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid_old: this.variableParser(request.classid_old),
      classid_new: this.variableParser(request.classid_new),
      // pre_reg_hd_id: this.variableParser(request.pre_reg_hd_id),
      // pre_reg_dtl_id: this.variableParser(request.pre_reg_dtl_id),
      user_type: this.variableParser(request.user_type),
      submit_userid: this.variableParser(request.submit_userid),
      submitip: this.variableParser(request.submitip),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/coordinator/classprechangebycourseschk", req);
    return data;
  }
  async saveClassprechangebycoursestu(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentid_list: this.variableParser(request.studentid_list),
      classid_old: this.variableParser(request.classid_old),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      courseid: this.variableParser(request.courseid),
      section: this.variableParser(request.section),
      ipaddress: "127.0.0.1", //this.variableParser(request.ipaddress),
      submit_userid: this.variableParser(request.submit_userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/coordinator/classprechangebycoursestu", req);
    return data;
  }
  async deleteClearpreregdata(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/clearpreregdata",
      {},
      {
        acadyear: this.variableParser(request.acadyear),
        semester: this.variableParser(request.semester),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async getCancelregbycourse(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      courseid: this.variableParser(request.courseid),
      section: this.variableParser(request.section),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/cancelregbycourse");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async cancelregbycourse(payload) {
    console.log("cancelregbycourse")
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentidlist: this.variableParser(request.studentidlist),
      sequencelist: this.variableParser(request.sequencelist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid: this.variableParser(request.classid),
      courseid: this.variableParser(request.courseid),
      userid: this.variableParser(request.userid),
      ipaddress: "127.0.0.1", //this.variableParser(request.ipaddress),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/cancelregbycourse", req);
    return data;
  }
  async getEnrollregextra(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      admitacadyear: this.variableParser(request.admitacadyear),
      admitsemester: this.variableParser(request.admitsemester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      statusfrom: this.variableParser(request.statusfrom),
      statusto: this.variableParser(request.statusto),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/enrollregextra");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getCancelrequestprereg(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      admitacadyear: this.variableParser(request.admitacadyear),
      admitsemester: this.variableParser(request.admitsemester),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/cancelrequestprereg");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getCancelrequestpreregbyco(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/cancelrequestpreregbyco");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async cancelRequestpreregAll(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      prereghdid: this.variableParser(request.prereghdid),
      preregstatus: this.variableParser(request.preregstatus),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/cancelrequestprereg", req);
    return data;
  }
  async cancelRequestpreregByone(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      preregdtlid: this.variableParser(request.preregdtlid),
      preregstatus: this.variableParser(request.preregstatus),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/cancelrequestpreregbyco", req);
    return data;
  }
  async postCancelreg(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      canceltype: this.variableParser(request.canceltype),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      duedate: this.variableParser(request.duedate),
      studentidlist: this.variableParser(request.studentidlist),
      condition: this.variableParser(request.condition),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/cancelreg", req);
    return data;
  }
  async cancelreg(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentidlist: this.variableParser(request.studentidlist),
      sequencelist: this.variableParser(request.sequencelist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      userid: this.variableParser(request.userid),
      ipaddress: this.variableParser(request.ipaddress),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.update("reg/enroll/staff/cancelreg", req);
    return data;
  }
  async getCoordinatoryear(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/coordinatoryear");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getCoordinatorbyofficer(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      officercode: this.variableParser(request.officercode),
      officername: this.variableParser(request.officername),
      facultyid: this.variableParser(request.facultyid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/coordinatorbyofficer");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getCoordinatorbyofficeryear(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      officercode: this.variableParser(request.officercode),
      officername: this.variableParser(request.officername),
      facultyid: this.variableParser(request.facultyid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/coordinatorbyofficeryear");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async postCoordinatoryear(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      coordinatorlist: this.variableParser(request.coordinatorlist),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/coordinatoryear", req);
    return data;
  }
  async postCoordinatorCourseCopy(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      acadyeardup: this.variableParser(request.acadyeardup),
      semesterdup: this.variableParser(request.semesterdup),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/coordinatorcoursecopy", req);
    return data;
  }
  async postCoordinatorCourse(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classid_list: this.variableParser(request.classid_list),
      coordinator_hd_id: this.variableParser(request.coordinator_hd_id),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      facultyid: this.variableParser(request.facultyid),
      coursegroup: this.variableParser(request.coursegroup),
      coursegroupdes: this.variableParser(request.coursegroupdes),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/coordinatorcourse", req);
    return data;
  }
  async postCoordinatorCourseFac(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      coordinator_hd_id: this.variableParser(request.coordinator_hd_id),
      officerid: this.variableParser(request.officerid),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/coordinatorcoursefac", req);
    return data;
  }
  async postcoordinatorcourselist(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      coordinator_hd_id: this.variableParser(request.coordinator_hd_id),
      officerid: this.variableParser(request.officerid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/addcoordinatorcourselist", req);
    return data;
  }
  async deleteCoordinatoryear(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/coordinatoryear",
      {},
      {
        officerid: this.variableParser(request.officerid),
        acadyear: this.variableParser(request.acadyear),
        semester: this.variableParser(request.semester),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async deleteCoordinatorCoursebyins(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/coordinatorcoursebyins",
      {},
      {
        coordinator_dtl_id: this.variableParser(request.coordinator_dtl_id),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async getCoordinatorcourse(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/coordinatorcourse");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getCoordinatorcoursefac(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      facultyid: this.variableParser(request.facultyid),
      coursegroup: this.variableParser(request.coursegroup),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/coordinatorcoursefac");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async deleteCoordinatorcourse(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/coordinatorcourse",
      {},
      {
        officerid: this.variableParser(request.officerid),
        acadyear: this.variableParser(request.acadyear),
        semester: this.variableParser(request.semester),
        levelid: this.variableParser(request.levelid),
        facultyid: this.variableParser(request.facultyid),
        coursegroup: this.variableParser(request.coursegroup),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async deleteCoordinatorcoursefac(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/coordinatorcoursefac",
      {},
      {
        acadyear: this.variableParser(request.acadyear),
        semester: this.variableParser(request.semester),
        levelid: this.variableParser(request.levelid),
        facultyid: this.variableParser(request.facultyid),
        coursegroup: this.variableParser(request.coursegroup),
        courseid: this.variableParser(request.courseid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }async deleteCoursebycourse(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/coordinatorcoursebycourse",
      {},
      {
        coordinator_hd_id: this.variableParser(request.coordinator_hd_id),
        classid: this.variableParser(request.classid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async getAdjustconditionadd(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      admitacadyear: this.variableParser(request.admitacadyear),
      admitsemester: this.variableParser(request.admitsemester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/adjustconditionadd");
    console.log('res', res)
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getAdjustcondition(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      admitacadyear: this.variableParser(request.admitacadyear),
      admitsemester: this.variableParser(request.admitsemester),
      levelid: this.variableParser(request.levelid),
      studentyear: this.variableParser(request.studentyear),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      programid: this.variableParser(request.programid),
      studentidfrom: this.variableParser(request.studentidfrom),
      studentidto: this.variableParser(request.studentidto),
      conapprove: this.variableParser(request.conapprove),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/adjustcondition");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async postAdjustCondition(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentid: this.variableParser(request.studentid),
      errorid: this.variableParser(request.errorid),
      courseid1: this.variableParser(request.courseid1),
      courseid2: this.variableParser(request.courseid2),
      creditmin: this.variableParser(request.creditmin),
      creditmax: this.variableParser(request.creditmax),
      classid1: this.variableParser(request.classid1),
      classid2: this.variableParser(request.classid2),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/adjustcondition", req);
    return data;
  }
  async postCoordinatorRightCopy(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      classidmain: this.variableParser(request.classidmain),
      classidminor_list: this.variableParser(request.classidminor_list),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/coordinator/coordinatorrightcopy", req);
    return data;
  }
  async postAdjustConditionList(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentidlist: this.variableParser(request.studentidlist),
      erroridlist: this.variableParser(request.erroridlist),
      courseid1: this.variableParser(request.courseid1),
      courseid2: this.variableParser(request.courseid2),
      creditmin: this.variableParser(request.creditmin),
      creditmax: this.variableParser(request.creditmax),
      classid1: this.variableParser(request.classid1),
      classid2: this.variableParser(request.classid2),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/adjustconditionlist", req);
    return data;
  }
  async getconditionlist(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/getconditionlist");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getConditionlistbystd(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/getconditionlistbystd");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getCurrentyearbylevelid(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      levelid: this.variableParser(request.levelid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/currentyearbylevelid");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async getAdjustconditionerror(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      levelid: this.variableParser(request.levelid),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/adjustconditionerror");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async delClearadjustcondition(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const data = await this.delete(
      "reg/enroll/staff/clearadjustcondition",
      {},
      {
        studentid: this.variableParser(request.studentid),
        errorid: this.variableParser(request.errorid),
        acadyear: this.variableParser(request.acadyear),
        semester: this.variableParser(request.semester),
        ipaddress: this.variableParser(request.ipaddress),
        userid: this.variableParser(request.userid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async getCourse(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      facultyid: this.variableParser(request.facultyid),
      coursegroup: this.variableParser(request.coursegroup),
      coursecode:this.variableParser(request.coursecode),
      coursename:this.variableParser(request.coursename),
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/coordinatorcoursegetcourse");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async delEnroll(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/enroll",
      {},
      {
        studentid: this.variableParser(request.studentid),
        classid: this.variableParser(request.classid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async getConfigCredit(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const res = await this.get("/reg/enroll/staff/configcredit");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
  async postEnrollregextragetclassreserve(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/enrollregextragetclassreserve", req);
    if (res.status == 500) {
      return { code: 500, message: res.message };
    }
    return res.data;
  }
  async postEnrollRegExtraGetClass(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/enrollregextragetclass", req);
    if (res.status == 500) {
      return { code: 500, message: res.message };
    }
    return res.data;
  }
  async postPreEnrollRegExtraGetClass(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/preenrollregextragetclass", req);
    if (res.status == 500) {
      return { code: 500, message: res.message };
    }
    return res.data;
  }
  async getPreEnrollRegExtraGetClassReserve(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const res = await this.get("/reg/enroll/staff/preenrollregextragetclassreserve");
    if (res.status == 500) {
      return [];
    }
    return res.data;
  }
  async enrollExtraCheckcon(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      lang: this.variableParser(request.lang),
    };
   const { data } = await this.update("reg/enroll/staff/enrollextracheckcon", req);
    return data;
  }

  async checkStudentCode(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/checkstudentcode", req);
    if (res.status == 500) {
      return { code: 500, message: res.message };
    }
    return res.data;
  }
  async postGetEnrollStdList(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/getenrollstdlist", req);
    return res.data;
  }
  async postGetPreEnrollStdList(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/getpreenrollstdlist", req);
    return res.data;
  }
  async savePreEnrollRegExtra(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid: this.variableParser(request.classid),
      remark: this.variableParser(request.remark),
      action: this.variableParser(request.action),
      userid: this.variableParser(request.userid),
      createip: this.variableParser(request.createip),
      lang: this.variableParser(request.lang),
    };
   const { data } = await this.update("reg/enroll/staff/preenrollregextra", req);
    return data;
  }
  async savePreEnrollRegExtraCon(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      action: this.variableParser(request.action),
      usertype: this.variableParser(request.usertype),
      method: this.variableParser(request.method),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang),
    };
   const { data } = await this.update("reg/enroll/staff/preenrollregextracon", req);
    return data;
  }
  async postPreEnrollRegExtraDetail(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const { data } = await this.create("reg/enroll/staff/preenrollregextradetail", req);
    return data;
  }
  async postPreEnrollregextragetclassreserve(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      studentlist: this.variableParser(request.studentlist),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang),
    };
    const res = await this.create("reg/enroll/staff/preenrollregextragetclassreserve", req);
    if (res.status == 500) {
      return { code: 500, message: res.message };
    }
    return res.data;
  }
  async deletePreEnrollRegExtraDetail(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete(
      "reg/enroll/staff/preenrollregextradetail",
      {},
      {
        studentlist: this.variableParser(request.studentlist),
        classid: this.variableParser(request.classid),
        userid: this.variableParser(request.userid),
        lang: this.variableParser(request.lang),
      }
    );
    return data;
  }
  async getCourseByAcad(payload) {
    const { token, request } = payload;
    this.setHeaderBearerAuth(token);
    const req = {
      coursecode: this.variableParser(request.coursecode),
      coursename: this.variableParser(request.coursename),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      lang: this.variableParser(request.lang),
    };
    const res = await this.get("/reg/enroll/coursebyacad", { ...req });
    if (res.status == 500) {
      return [];
      //return { code: 500, message: res.message };
    }
    return res.data;
  }
  async getaction(payload) {
    const { token, request } = payload;
    const req = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      lang: this.variableParser(request.lang),
    };
    this.setHeader(req);
    const res = await this.get("reg/enroll/staff/getaction");
    if (res.status == 500) {
      return [];
    }
    const { data } = res.data;
    return data;
  }
}

export default EnrollProvider;

